/**
 * Svelte action to detect clicks outside an element
 * Usage: <div use:clickOutside={handleClickOutside}>
 */
export function clickOutside(node: HTMLElement, callback: () => void) {
  const handleClick = (event: MouseEvent) => {
    if (node && !node.contains(event.target as Node) && !event.defaultPrevented) {
      callback();
    }
  };

  document.addEventListener('click', handleClick, true);

  return {
    update(newCallback: () => void) {
      callback = newCallback;
    },
    destroy() {
      document.removeEventListener('click', handleClick, true);
    }
  };
}
